import { StateNode } from '@ansys-internal/awf-angular/store';
import { ConceptPopulated } from 'src/api';

export class ActiveConceptState
  implements StateNode<ConceptPopulated | undefined>
{
  key: string = 'activeConcept';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => ConceptPopulated | undefined = () => undefined;
}
